// extracted by mini-css-extract-plugin
module.exports = {"actionCompletePage":"ActionCompletePage_actionCompletePage__1D_Ip","actionCompleteBlock":"ActionCompletePage_actionCompleteBlock__1-jbs"};